import React from 'react';
import { connect } from 'react-redux';
import LeadForm from './LeadForm';
import useBO from '../useBO';
import useTO from '../useTO';
import useFSC from '../useFSC';
import useOptions from '../useOptions';
import useVersion from '../useVersion';
import useRoles from '../useRoles';
import { create } from '../../actions/lead';

const New = (props) => {
  let { values, onSubmit } = props;
  let bo = useBO();
  let to = useTO();
  let fsc = useFSC();
  let options = useOptions();
  let version = useVersion();
  let roles = useRoles();

  return (
    <div className='container pt-3'>
      <div className='h3 text-primary my-3'>GIỚI THIỆU KHÁCH HÀNG</div>
      <LeadForm
        values={values}
        bank={props.bank}
        bo={bo}
        to={to}
        fsc={fsc}
        options={options}
        version={version}
        roles={roles}
        onSubmit={onSubmit}
        new
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  const officeCode = state?.lookup?.profile?.toCode;
  const branchCode = state?.lookup?.profile?.boCode;
  const fscCode = state?.lookup?.profile?.fscCode;
  const bank = state?.lookup?.bank;
  const leader = state?.lookup?.leader;

  const leaderDescription = 'VCB' === bank && leader ? `${leader.agentName}_${leader.businessCd}` : '';
  const leaderCode = 'VCB' === bank && leader ? leader.businessCd : '';

  const values = {
    officeCode, branchCode, fscCode, interest: '', leaderDescription, leaderCode,
  };
  return { values, bank };
};

const mapDispatchToProps = { onSubmit: create };

export default connect(mapStateToProps, mapDispatchToProps)(New);
